import AppDispatcher from '../dispatcher/AppDispatcher';
import constants from '../constants/TagConstants';

class TagActions {

    loadAllTagsRequest() {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_ALL_TAGS_REQUEST,
        });
    }

    loadAllTags(tags) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_ALL_TAGS,
            tags
        });
    }

    loadTagRequest(tagKey) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_TAG_REQUEST,
            tagKey
        });
    }

    loadTag(tag) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_TAG,
            tag
        });
    }

    insertTag(tag,isOutputTag) {
        AppDispatcher.handleServerAction({
            type: constants.ADD_TAG,
            tag,
            isOutputTag
        });
    }

    updateTag(tag) {
        AppDispatcher.handleServerAction({
            type: constants.UPDATE_TAG,
            tag
        });
    }

    deleteTag(TagKey) {
        AppDispatcher.handleServerAction({
            type: constants.DELETE_TAG,
            TagKey
        });
    }

    loadTagsByWell(tags) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_TAGS_BY_WELL,
            tags
        });
    }

    addTagsToWell(tags){
        AppDispatcher.handleServerAction({
            type: constants.ADD_TAGS_TO_WELL,
            tags
        });
    }

    removeTagFromWell(tag){
        AppDispatcher.handleServerAction({
            type: constants.REMOVE_TAG_FROM_WELL,
            tag
        });
    }

    removeTagsFromWell(tags){
        AppDispatcher.handleServerAction({
            type: constants.REMOVE_TAGS_FROM_WELL,
            tags
        });
    }

    //state tags-----------------------------------------------------------------
    loadAllStateTagsRequest() {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_ALL_STATE_TAGS_REQUEST,
        });
    }

    loadAllStateTags(tags) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_ALL_STATE_TAGS,
            tags
        });
    }

    loadStateTagRequest(tagKey) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_STATE_TAG_REQUEST,
            tagKey
        });
    }

    loadStateTag(tag) {
        AppDispatcher.handleServerAction({
            type: constants.LOAD_STATE_TAG,
            tag
        });
    }

    insertStateTag(tag) {
        AppDispatcher.handleServerAction({
            type: constants.ADD_STATE_TAG,
            tag
        });
    }

    updateStateTag(tag) {
        AppDispatcher.handleServerAction({
            type: constants.UPDATE_STATE_TAG,
            tag
        });
    }

    updateStates(tagKey,states){
        AppDispatcher.handleServerAction({
            type: constants.UPDATE_STATES,
            tagKey,
            states
        });
    }

    deleteStates(TagKey,states) {
        AppDispatcher.handleServerAction({
            type: constants.DELETE_STATES,
            TagKey
        });
    }

}
export default new TagActions();